import React, { createContext, useContext, useMemo, useState } from 'react';

export interface AiPanelLayoutContextValue {
  mountNode: HTMLDivElement | null;
  setMountNode: (el: HTMLDivElement | null) => void;
  /** Main+AI grid root; used to align the AI rail to the viewport (shadow-DOM safe). */
  shellGridNode: HTMLDivElement | null;
  setShellGridNode: (el: HTMLDivElement | null) => void;
}

const AiPanelLayoutContext = createContext<AiPanelLayoutContextValue | null>(
  null,
);

export function AiPanelLayoutProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [mountNode, setMountNode] = useState<HTMLDivElement | null>(null);
  const [shellGridNode, setShellGridNode] = useState<HTMLDivElement | null>(
    null,
  );
  const value = useMemo(
    () => ({
      mountNode,
      setMountNode,
      shellGridNode,
      setShellGridNode,
    }),
    [mountNode, shellGridNode],
  );

  return (
    <AiPanelLayoutContext.Provider value={value}>
      {children}
    </AiPanelLayoutContext.Provider>
  );
}

export function useAiPanelLayout(): AiPanelLayoutContextValue | null {
  return useContext(AiPanelLayoutContext);
}
